import {FC, useEffect, useState} from 'react';
import {Redirect, useParams} from 'wouter';

import {asNumberOrThrow} from '@shared/lib/utils/type_utils';
import {FrontendAccountNotification} from '@shared/models/api_models';
import {PreciseTimestamp} from '@shared/models/core_models';

import {useResponsive} from '@shared_web/breakpoints';
import {notifyError} from '@shared_web/lib/notification';

import {Loader} from '@mavismart_frontend/components/loader';
import {apiCall} from '@mavismart_frontend/lib/api';
import {DoorTabs} from '@mavismart_frontend/pages/door_tabs';

export const NotificationPage: FC = () => {
  const {isDesktop} = useResponsive();
  const {notificationId} = useParams<{
    notificationId?: string;
  }>();

  const [notification, setNotification] = useState<FrontendAccountNotification | undefined>(
    undefined
  );
  useEffect(() => {
    setNotification(undefined);
    if (notificationId === undefined) {
      return;
    }
    apiCall('POST /get-account-notification', {
      ts: asNumberOrThrow<PreciseTimestamp>(notificationId),
    })
      .then(response => {
        setNotification(response.notification);
      })
      .catch(notifyError);
  }, [notificationId]);

  if (!notificationId) {
    return <></>;
  }
  if (notification === undefined) {
    return <Loader />;
  }

  if (notification.doorId === undefined || notification.doorMessage === undefined) {
    console.error('Notification has no doorId or doorMessage', notification);
    return <></>;
  }

  if (!isDesktop) {
    return (
      <Redirect
        to={`/doors/${notification.doorId}/messages/${notification.doorMessage.category}`}
        replace
      />
    );
  }

  return (
    <DoorTabs doorId={notification.doorId} baseUrl={`/user/notifications/${notificationId}`} />
  );
};

NotificationPage.displayName = 'NotificationPage';
